import { ApiList } from './ApiList';
import { ApiShow } from './ApiShow';
import { IconApi } from '../ui/icons';

export const apis = {
    icon: IconApi,
    list: ApiList,
    show: ApiShow,
};

export * from './ApiList';
export * from './ApiShow';
export * from './ApiCard';
